import { render, staticRenderFns } from "./WrongClassExe.vue?vue&type=template&id=665b8ee2&scoped=true"
import script from "./WrongClassExe.vue?vue&type=script&lang=js"
export * from "./WrongClassExe.vue?vue&type=script&lang=js"
import style0 from "./WrongClassExe.vue?vue&type=style&index=0&id=665b8ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b8ee2",
  null
  
)

export default component.exports